const overflow = (str, length) => {
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    let strings = str.slice(0, length - 3);
    strings += "...";
    return strings;
  } else {
    return str;
  }
};
export default overflow;
